import { Api } from '@blink/components';
import { useCallback } from 'react';

export const useHandleSignIn = () => {
    return useCallback(() => {
        window.location.href = `${Api.API_AUTH_ENDPOINT}/start?rd=${window.location}`;
    }, []);
};
